export function buildAppointmentProcedureLines(appointment = {}) {
  const structured = normalizeStructuredLines(appointment.procedure_line_items);
  if (structured.length > 0) return structured;

  if (typeof appointment.procedures === "string") {
    return appointment.procedures
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean);
  }

  return [];
}

function normalizeStructuredLines(items) {
  if (!Array.isArray(items)) return [];
  return items
    .map((item) => formatProcedureLine(item))
    .filter(Boolean);
}

function formatProcedureLine(item = {}) {
  const label = item.label || item.display_label || item.procedure_name;
  if (!label) return "";

  const parts = [label];
  if (item.template_label) parts.push(item.template_label);

  const teeth = normalizeTeeth(item.teeth);
  if (teeth.length > 0) {
    parts.push(teeth.length === 1 ? `Tooth ${teeth[0]}` : `Teeth ${teeth.join(", ")}`);
  } else if (item.tooth_number) {
    parts.push(`Tooth ${item.tooth_number}`);
  }

  if (item.surface) parts.push(String(item.surface).trim());

  return parts
    .map((part) => String(part).trim())
    .filter(Boolean)
    .join(" - ");
}

function normalizeTeeth(teeth) {
  if (Array.isArray(teeth)) {
    return teeth.map(normalizeToothLabel).filter(Boolean);
  }
  if (typeof teeth === "string") {
    return teeth.split(",").map((tooth) => tooth.trim()).filter(Boolean);
  }
  return [];
}

function normalizeToothLabel(tooth) {
  if (tooth == null) return "";
  if (typeof tooth === "string" || typeof tooth === "number") {
    return String(tooth).trim();
  }
  if (typeof tooth !== "object") return "";

  const value = tooth.fdi
    ?? tooth.tooth
    ?? tooth.tooth_number
    ?? tooth.number
    ?? tooth.id
    ?? "";
  return String(value).trim();
}
